import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckoutForm from "../components/CheckoutForm";
import { updateBilling } from "../actions/account.ts";
import { getAccountSubscription } from "../selectors/currentAccountSelector.ts";
import QueryString from "query-string";
import styles from "../styles/ProfileManagePaymentPage.module.scss";

export default function ManagePaymentPage(props) {
  const dispatch = useDispatch();
  const subscription = useSelector(getAccountSubscription);
  const currentUrl = new URL(window.location);
  const urlQuery = QueryString.parse(currentUrl.search);
  const [product, setProduct] = useState("");

  function onLoad() {
    if (urlQuery["product"]) {
      const product = urlQuery["product"];
      setProduct(product);
    }
  }

  useEffect(() => {
    onLoad(); //eslint-disable-next-line
  }, []);

  const handleSubmitClick = async (paymentMethod, result) => {
    const { id } = paymentMethod;
    const { subscriptionId } = subscription.find((sub) => {
      return sub.product===product;
    });
    await dispatch(updateBilling(subscriptionId, id));
  };

  const formStyles = {
    title: "",
    buttonCTA: "UPDATE",
    alignItems: "flex-start",
    backgroundColor: "transparent",
    border: false,
    darkMode: true,
    padding: "36px 36px 36px 0",
    paymentFormBackground: "transparent",
    height: "100%",
    width: "100%",
    color: "white",
  };

  return (
    <>
      {/* <BreadcrumbWrapper> */}
      <h1 className={styles.title}>Manage Payment Method</h1>

      <CheckoutForm
        formStyles={formStyles}
        handleSubmitCallback={handleSubmitClick}
        emailRequired={false}
        loadingMessage={"Payment method updating..."}
        successHeaderMessage={"Payment method update successful!"}
        successMessage={"Payment method updated."}
        darkMode
      />
      {/* </BreadcrumbWrapper> */}
    </>
  );
}
